import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from './Header';
import Footer from './Footer';

const TermsOfUse: React.FC = () => {
    return (
        <div className="d-flex flex-column min-vh-100">
            <Header />
            <main className="flex-grow-1 py-5">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto">
                            <h1 className="mb-4">Terms of Use</h1>
                            <p className="text-muted mb-4">
                                Last updated: {new Date().toLocaleDateString()}
                            </p>

                            <section className="mb-4">
                                <h2>Acceptance of Terms</h2>
                                <p>
                                    By accessing and using Press Forward Mail, you accept and agree
                                    to be bound by the terms and provision of this agreement.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h2>Service Description</h2>
                                <p>
                                    Press Forward Mail provides email forwarding services for
                                    missionaries to share updates with friends and family members.
                                    We reserve the right to modify or discontinue the service at any
                                    time.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h2>User Responsibilities</h2>
                                <p>You agree to:</p>
                                <ul>
                                    <li>Provide accurate and complete information</li>
                                    <li>Use the service only for lawful purposes</li>
                                    <li>
                                        Not send spam, malicious content, or inappropriate material
                                    </li>
                                    <li>Respect the privacy and rights of others</li>
                                    <li>Maintain the security of your account credentials</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h2>Prohibited Uses</h2>
                                <p>You may not use our service to:</p>
                                <ul>
                                    <li>Send unsolicited commercial email or spam</li>
                                    <li>Transmit harmful, offensive, or illegal content</li>
                                    <li>Violate any applicable laws or regulations</li>
                                    <li>Interfere with or disrupt the service</li>
                                </ul>
                            </section>

                            <section className="mb-4">
                                <h2>Payment Terms</h2>
                                <p>
                                    Subscription fees are billed in advance and are non-refundable.
                                    We reserve the right to change our pricing with 30 days notice.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h2>Limitation of Liability</h2>
                                <p>
                                    Press Forward Mail shall not be liable for any indirect,
                                    incidental, special, consequential, or punitive damages
                                    resulting from your use of the service.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h2>Termination</h2>
                                <p>
                                    We may terminate or suspend your account immediately, without
                                    prior notice, for conduct that we believe violates these Terms
                                    of Use.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h2>Changes to Terms</h2>
                                <p>
                                    We reserve the right to modify these terms at any time. We will
                                    notify users of any material changes via email or through the
                                    service.
                                </p>
                            </section>

                            <section className="mb-4">
                                <h2>Contact Information</h2>
                                <p>
                                    For questions about these Terms of Use, please contact us at
                                    legal (at) pressforwardmail.com
                                </p>
                            </section>
                        </Col>
                    </Row>
                </Container>
            </main>
            <Footer />
        </div>
    );
};

export default TermsOfUse;
